import React from 'react';
import logo from './img/spotifood-logo.svg';
import * as S from './Header.style';
export const Header = ({ user, signOut }) => (React.createElement(S.Header, null,
    React.createElement(S.SpotifoodLogo, { src: logo, alt: 'Logo', width: '124', height: '45' }),
    user && (React.createElement(S.User, null,
        React.createElement(S.NameWrapper, null,
            React.createElement(S.DisplayName, null, user.display_name),
            React.createElement(S.SignOutLink, { onClick: () => signOut === null || signOut === void 0 ? void 0 : signOut() }, "Sair")),
        React.createElement(S.Avatar, { src: user.images[0].url, alt: user.display_name })))));
//# sourceMappingURL=Header.js.map